import {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';

import deviceActions from '@state/device/actions';
import devicesApi from '@api/devicesApi';
import getColumns from './columnsDevices';

function useDispositivos() {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientTarget = useSelector(({ user }) => user.clientTarget);
  const abortController = useRef(null);
  const unmountcomponent = useRef(true);
  // const timeoutRef = useRef();
  const timerLopping = useRef();
  const initPagination = useRef({ current: 1, pageSize: 20 });
  const history = useHistory();
  const search = '';
  const [valueFilter, setValueFilter] = useState('');
  // const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingActive, setLoadingActive] = useState(false);
  const [devices, setDevices] = useState([]);

  const [pag, setPagination] = useState(initPagination.current);

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const abortLastRequest = useCallback(() => {

    if (abortController.current) {

      abortController.current.abort();
      abortController.current = null;

    }

  }, []);

  const handleTableChange = useCallback( // load device data
    (pagination, filter, sorter) => {

      const { id: client } = clientTarget;
      const { current, pageSize: limit } = pagination;
      const offset = (current - 1) * limit;

      const { columnKey, order } = sorter || {};
      const ordering = columnKey ? `${order === 'descend' ? '-' : ''}${columnKey}` : undefined;

      abortController.current = new AbortController();
      const { signal } = abortController.current;

      setLoading(true);
      if (timerLopping.current) clearTimeout(timerLopping.current);

      devicesApi
        .devicesTelemetry({
          client, offset, limit, ordering, search, signal,
        })
        .then(async (response) => {

          if (unmountcomponent) {

            const resp = {
              count: response.lenght,
              results: response,
            };
              // eslint-disable-next-line no-shadow
            const { results: devices, count: total } = resp;
            setPagination({ ...pagination, total });
            setLoading(false);

            const newDevices = await Promise.all(devices.map(async (obj) => {

              const arrDevicesType = obj?.device_types.map((item) => item.name) || [];
              const device_types_name = arrDevicesType.join(', ');
              const item = { ...obj, device_types_name };
              return item;

            }));

            setDevices(newDevices);

            timerLopping.current = setTimeout(
              () => handleTableChange({ pagination, filter, sorter }),
              120000,
            );

          }

        })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

    },
    [clientTarget, search, t],
  );

  useEffect( // mount component
    () => {

      handleTableChange(initPagination.current);
      return abortLastRequest;

    },
    // eslint-disable-next-line
    []
  );

  const createDevice = useCallback( // Go to create /crear-dispositivo
    () => {

      history.push('/dispositivos/crear-dispositivo');

    },
    [history],
  );

  const deleteDevice = useCallback((e) => { // Delete device by Id

    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const { id } = e;
    devicesApi.deleteDeviceById({ signal, id })
      .then((response) => {

        if (unmountcomponent) {

          message.success(t('common.remove_success'));
          handleTableChange(initPagination.current);

        }

      })
      .catch((error) => {

        message.error(t('common.failed_remove'));

      });

  // eslint-disable-next-line
  }, []);

  const editDevice = useCallback((e) => { // edit device, save data device in redux

    const defaultData = {
      name: e.name,
      client: e.client,
      business_type_id: e?.business_type?.id || '',
      device_type_id: e?.device_types?.map((item) => (item.id)) || [],
      slvId: `${e?.slvId}` || '',
      gateway_id: e?.gateway?.id || '',
    };

    dispatch(deviceActions.setDeviceIdEdit(e.id));
    dispatch(deviceActions.setCreateEditDevice(defaultData));
    history.push('/dispositivos/editar-dispositivo');

  }, [dispatch, history]);

  const onSetActive = useCallback(
    (checked, record) => {

      const body = { can_check_cs: checked };

      setLoadingActive(true);
      devicesApi
        .partialUpdateAlarm({ id: record.id, body })
        .then((response) => {

          if (unmountcomponent) {

            setDevices(devices.map((data) => {

              if (data.id === response.id) {

                return { ...data, can_check_cs: response.can_check_cs };

              }
              return data;

            }));
            setLoadingActive(false);

          }

        })
        .catch((resError) => {

          const { fem } = resError;
          // eslint-disable-next-line
          console.log(t(fem));
          setLoadingActive(false);

        });

    },
    [devices, t],
  );

  const columns = useMemo(
    () => getColumns(t, deleteDevice, currentUser, editDevice),
    [t, deleteDevice, currentUser, editDevice],
  );

  const arrayFilter = devices.filter((data) => ( // Filter by client
    data.name.toUpperCase().includes(valueFilter.toUpperCase())
  ));

  const getPermissonCreate = useCallback(() => {

    const currentUserRole = currentUser.role;
      // eslint-disable-next-line
      setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

  }, []);

  useEffect(() => {

    getPermissonCreate();

}, []);

  useEffect(() => () => {

    unmountcomponent.current = false;
    clearTimeout(timerLopping.current);

  });

  return {
    setValueFilter,
    handleTableChange,
    loading,
    arrayFilter,
    devices,
    columns,
    pagination: pag,
    createDevice,
    onSetActive,
    loadingActive,
    isCreate,
    // onChangeSearch,
  };

}

export default useDispositivos;
